const EN_US = {
  'auditLogsDomain.title': 'Activity log',
  'auditLogsDomain.subtitle': 'All Audit Logs',
  'auditLogsDomain.list.filter.accountSearch.placeholder': 'Search by email',
  'auditLogsDomain.list.header.eventTime': 'Event Time',
  'auditLogsDomain.list.header.account': 'Account',
  'auditLogsDomain.list.header.accountId': 'Account ID:',
  'auditLogsDomain.list.header.eventName': 'Event',
  'auditLogsDomain.list.header.entities': 'Target Objects',
  'auditLogsDomain.list.noResults':
    'No audit logs found, try changing or removing some of the filters.',
  'auditLogsDomain.list.entities.ids': 'IDs',

  // Audit Log Event Names
  // - Optional. If no translation specified, will default to an auto-generated name based on event name.
  'auditLogsDomain.eventName.enterpriseAccountCreate': 'Create account',
  'auditLogsDomain.eventName.enterpriseAccountUpdate': 'Update account',
  'auditLogsDomain.eventName.enterpriseAccountSetDisabled': 'Deactivate or reactivate account',
  'auditLogsDomain.eventName.productAddToAisle': 'Add product to aisle',
  'auditLogsDomain.eventName.retailerMfaSetEnabled': 'Enable 2FA for retailer',
  'auditLogsDomain.eventName.enterpriseAccountMfaEnable': 'Enable MFA for account',
  'auditLogsDomain.eventName.enterpriseAccountMfaReset': 'Reset MFA for account',
  'auditLogsDomain.eventName.enterpriseAccountMfaDeactivate': 'Deactivate MFA for account',

  // Legacy Event Names
  'auditLogsDomain.eventName.legacyRetailersApiCreateUser': 'Create account',
  'auditLogsDomain.eventName.legacyRetailersApiUpdateUser': 'Update account',
  'auditLogsDomain.eventName.legacyRetailersApiDestroyUser': 'Deactivate account',
  'auditLogsDomain.eventName.legacyRetailersApiReactivateUser': 'Reactivate account',
  'auditLogsDomain.eventName.legacyRetailersApiUpdateProduct': 'Update product',
  'auditLogsDomain.eventName.legacyRetailersApiCreateProductRequest': 'Create product request',
  'auditLogsDomain.eventName.legacyRetailersApiProductAddToAisle': 'Add product to aisle',
  'auditLogsDomain.eventName.legacyRetailersApiProductAddToAisleBulk': 'Bulk add products to aisle',
  'auditLogsDomain.eventName.legacyRetailersApiProductAddAisle': 'Add product to aisle',
  'auditLogsDomain.eventName.legacyRetailersApiProductChangeAisle': 'Change product aisle',
  'auditLogsDomain.eventName.legacyRetailersApiProductRemoveAisle': 'Remove product from aisle',
  'auditLogsDomain.eventName.legacyRetailersApiProductRemoveFromAisle': 'Remove product from aisle',
  'auditLogsDomain.eventName.legacyRetailersApiProductChangeMainAisleBulk':
    'Bulk change main aisle for products',
  'auditLogsDomain.eventName.legacyRetailersApiCreateAisle': 'Create aisle',
  'auditLogsDomain.eventName.legacyRetailersApiUpdateAisle': 'Update aisle',
  'auditLogsDomain.eventName.legacyRetailersApiDestroyAisle': 'Delete aisle',
  'auditLogsDomain.eventName.legacyRetailersApiCreateDepartment': 'Create department',
  'auditLogsDomain.eventName.legacyRetailersApiUpdateDepartment': 'Update department',
  'auditLogsDomain.eventName.legacyRetailersApiDestroyDepartment': 'Delete department',
  'auditLogsDomain.eventName.legacyRetailersApiUpdateItem': 'Update product pricing/availability',
  'auditLogsDomain.eventName.legacyRetailersApiUpdateItemBulk':
    'Bulk update product pricing/availability',
  'auditLogsDomain.eventName.legacyRetailersApiCreateItemBulk': 'Add product to stores',
} as const

export default EN_US
